module.exports = __webpack_public_path__ + "img/img3.854a9c66.jpg";